import { render, staticRenderFns } from "./RegisteredEmail.vue?vue&type=template&id=318d5c5b&scoped=true&"
import script from "./RegisteredEmail.vue?vue&type=script&lang=js&"
export * from "./RegisteredEmail.vue?vue&type=script&lang=js&"
import style0 from "./RegisteredEmail.vue?vue&type=style&index=0&id=318d5c5b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "318d5c5b",
  null
  
)

export default component.exports